var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPadlockLocked = function SvgPadlockLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "padlock-locked_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.233.839h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#padlock-locked_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.233,
    y: 11.839,
    width: 12,
    height: 8.152,
    rx: 1.259
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.713 9.359a4.52 4.52 0 1 1 9.04 0v5.692a1 1 0 1 1-2 0V9.359a2.52 2.52 0 1 0-5.04 0v3.531a1 1 0 1 1-2 0V9.36Z",
    fill: "currentColor"
  }))));
};
export default SvgPadlockLocked;